import { Box } from '@mui/material';
import type { ReactNode } from 'react';

import { ColorControl } from '../../workspace/tools/ShapeToolDialog';
import { shapePanelSx } from './inlineMenuStyles';

interface ShapeColorPanelProps {
  children?: ReactNode;
  label: string;
  onChange: (color: string) => void;
  previewColor: string;
  value: string;
}

export function ShapeColorPanel({
  children,
  label,
  onChange,
  previewColor,
  value,
}: ShapeColorPanelProps) {
  return (
    <Box sx={shapePanelSx}>
      {children}
      <ColorControl label={label} onChange={onChange} previewColor={previewColor} value={value} />
    </Box>
  );
}
